import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { AppSidebar } from '@/components/app-sidebar'
import { RequireStaff } from '@/features/auth/guards'

export function DashboardLayout(): ReactNode {
  return (
    <RequireStaff>
      <AppSidebar>
        <Outlet />
      </AppSidebar>
    </RequireStaff>
  )
}
